import React, { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './LocationIdPage.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, IRootState } from '../redux/rootReducer';
import { getLocationById, getLocationPublicDetailsById } from '../redux/location/actions/location.action';
import Loader from '../components/common/loader/Loader';
import pineappleLogo from '../images/core/pineapple-logo-black-text.svg';
import ListingUnavailable from '../components/listing-unavailable/ListingUnavailable';

const LocationIdPage = () => {
    const { id } = useParams<{ id: string }>();
    const {
        data: locationData,
        loading: locationLoading,
        error: locationError,
    } = useSelector((state: IRootState) => state.locationReducer.locationPublicDetails);
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        if (id && !hasCalledAPI.current) {
            hasCalledAPI.current = true;
            dispatch(getLocationPublicDetailsById(id));
        }
    }, [id, dispatch]);

    const handleSignup = () => {
        navigate('/signup', { state: { destinationURL: `/location/${id}` } });
    };

    const handleLogin = () => {
        navigate('/login', { state: { destinationURL: `/location/${id}` } });
    };

    const handleVendorAccess = () => {
        navigate(`/vendor-access/${id}`);
    };

    const handleKeyDrop = () => {
        navigate(`/key-pickup-drop-access/${id}`);
    };

    return (
        <div
            className={`${styles.container}  ${
                locationData?.data && locationData?.data?.images?.length ? styles.propertyImageWrapper : ''
            }`}
            style={
                locationData?.data?.images?.[0]
                    ? {
                          backgroundImage: `url(${locationData?.data?.images[0]})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundAttachment: 'fixed',
                          width: '100%',
                      }
                    : {}
            }>
            {locationLoading ? (
                <Loader />
            ) : locationError && (locationError as any)?.isInactive ? (
                <ListingUnavailable />
            ) : (
                locationData && (
                    <div className={styles.content}>
                        <div className={styles.logoContainer}>
                            <img src={pineappleLogo} alt="Pineapple Logo" className={styles.logo} />
                        </div>
                        <h1 className={styles.title}>{`Welcome to ${locationData?.data?.name || 'Pineapple'}`}</h1>
                        <div className={styles.buttonContainer}>
                            <div className={styles.buttonGroup}>
                                <button className={styles.signupButton} onClick={handleSignup}>
                                    <p>Walk-Up Self-Tour</p>
                                    <p className={styles.buttonDescription}>( Book your appointment now! )</p>
                                </button>
                            </div>

                            <div className={styles.buttonGroup}>
                                <button className={styles.loginButton} onClick={handleLogin}>
                                    <p>Pre-Booked Self-Tour</p>
                                    <p className={styles.buttonDescription}>( Start your tour now! )</p>
                                </button>
                            </div>

                            <div className={styles.buttonGroup}>
                                <button className={styles.vendorButton} onClick={handleVendorAccess}>
                                    <p>Supplier Access</p>
                                    <p className={styles.buttonDescription}>( Start Here )</p>
                                </button>
                            </div>

                            <div className={styles.buttonGroup}>
                                <button className={styles.keyDropButton} onClick={handleKeyDrop}>
                                    <p>Key Pickup & Drop</p>
                                    <p className={styles.buttonDescription}>( Pick & drop the Keys )</p>
                                </button>
                            </div>
                            {/* <div className={styles.buttonGroup}>
              <a
                className={styles.contactButton}
                target='_blank'
                rel='noopener noreferrer'
                // onClick={handleContactOffice}
                href={`tel:+${locationData?.vendor?.leasingAgentNumber || `18887511211p800`}`}
              >
                Contact Office
              </a>
            </div> */}

                            {/* Contact Office Link */}
                            <div className={styles.contactSection}>
                                <p className={styles.contactText}>
                                    Need help?
                                    <a
                                        className={styles.contactButton}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href={`tel:+${locationData?.data?.leasingAgentNumber || `18887511211p800`}`}>
                                        Contact Office
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default LocationIdPage;
